import { render, staticRenderFns } from "./trainingModuleForm.vue?vue&type=template&id=12a55e0c"
import script from "./trainingModuleForm.vue?vue&type=script&lang=js"
export * from "./trainingModuleForm.vue?vue&type=script&lang=js"
import style0 from "./trainingModuleForm.vue?vue&type=style&index=0&id=12a55e0c&prod&lang=css"
import style1 from "./trainingModuleForm.vue?vue&type=style&index=1&id=12a55e0c&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports